<iframe src="/diplom"></iframe>
